import LoginPage from "./LoginPage";
import LayoutMain from "../layouts/main";
import { getStoredToken } from "../services/auth.service";

const RootPage = () => {
  const hasActiveSession = Boolean(getStoredToken());

  if (hasActiveSession) {
    return <LayoutMain />;
  }

  return <LoginPage />;
};

export default RootPage;
